import { dataRotateAnticlockwise } from 'dls-icons-data'
import { createIcon } from '../common'

const IconRotateAnticlockwise = /*#__PURE__*/createIcon(dataRotateAnticlockwise)
export default IconRotateAnticlockwise
